import { Button, Space, Typography, Form, Input, Divider, Row, Col, Tooltip, InputNumber } from "antd";
import { EditIcon, TrashIcon } from "../../admin/Icons";
import { ColorPicker } from 'react-color-gradient-picker';
import wrap from "../../utils/wrap";
import { canDeleteRecord, makeKey, tt_gradient_delete, tt_gradient_reset } from "../../utils/Utils";
import Overlay from "../Overlay";
import { useState } from "react";
import { RedoOutlined } from '@ant-design/icons';
export const getStyle = (_colors = [], _id = 0) => {
    let _f = _colors.find(item => item.id == _id);
    if (_f) {
        return _f.gradient.style;
    } else {
        return ""
    }
}

export default function Gradient(props) {

    // Pass functions and parameters
    const {
        template = {},
        templates = [],
        reset = () => { },
        remove = () => { },
        save = () => { },
        close = () => { },
        is_new = false,
        is_edit = false,
        data = {}
    } = props;

    // Destructure / Default

    const {
        id = 0,
        name = "",
        style = "linear-gradient(0deg,rgba(0, 0, 0, 1) 0%,rgba(255, 0, 0, 1) 100%)",
        points = [{ left: 0, red: 0, green: 0, blue: 0, alpha: 1, }, { left: 100, red: 255, green: 0, blue: 0, alpha: 1, },],
        degree = 0,
        type = 'linear',
    } = data;


    const can_delete = canDeleteRecord(templates, template, id, "gradients");
    const [form] = Form.useForm();
    // Structured object for picker component
    const [color, setColor] = useState(
        {
            points: points,
            degree: degree,
            type: type,
            style: style
        }
    )

    const drawPreview = () => {
        return (<div className="color-preview" style={{ "background": style }}></div>)
    }

    // Save Colour
    const saveColor = (_form) => {
        _form.points = color.points;
        _form.degree = color.degree;
        _form.type = color.type;
        _form.style = color.style;
        save(_form, is_new, true);
        close();
    }

    // Update State
    const updateColor = (_color) => {
        setColor(_color)
        setDeg(_color.degree)
    }

    const [deg, setDeg] = useState(color.degree);

    const generateGradientStyle = (data) => {
        const { points, degree } = data;
        const degreeString = `${degree}deg`;
        const colorStops = points.map(point => {
          const { left, red, green, blue, alpha } = point;
          return `rgba(${red}, ${green}, ${blue}, ${alpha}) ${left}%`;
        }).join(',');
        return `linear-gradient(${degreeString}${degreeString ? ', ' : ''}${colorStops})`;
      }


    // Draw the edit form
    const drawEdit = () => {
        let _new = (is_new) ? "New" : "Edit";
        return (
            <div onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        form.submit();
                        e.stopPropagation();
                        e.preventDefault();
                    }
                }} key={id} style={{ "padding": "20px" }}>
                <Typography.Title level={5}>{_new} {(!name && <>Gradient</>)} {(name && <em>"{name}"</em>)}</Typography.Title>
                <Divider style={{ "margin": "15px 0px" }} dashed />
                <Form form={form} onFinish={(_f) => saveColor(_f)} layout="vertical">
                    <Space>
                        <Form.Item initialValue={name} rules={[{ required: true, message: "Gradient name is required." }]} name="name" label={<>Colour name<small><em>&nbsp; (Max 20 chars)</em></small></>}>
                            <Input style={{"width" : "205px"}} placeholder="Colour name..." maxLength={20} />
                        </Form.Item>
                        <Form.Item label={<><small>Angle</small></>}>
                            <InputNumber style={{"width" : "65px"}} value={deg} min={0} max={359} onChange={(e) => { updateColor({ ...color, "degree": (e) ? e : 0 }); }} />
                        </Form.Item>
                    </Space>
                    <div className="checker-bg" style={{ "width": "278px", "height": "90px", "borderRadius": "8px", "marginTop": "0px" }}>
                        <div style={{ "background": generateGradientStyle(color), "width": "278px", "height": "90px", "border": "1px solid #ddd", "borderRadius": "8px" }}></div>
                    </div>
                    <div className="shim" /><div className="shim" />
                    <Form.Item name="id" initialValue={(id) ? id : makeKey()} noStyle>
                        <Input hidden />
                    </Form.Item>
                    <ColorPicker isGradient={true} gradient={color} onStartChange={updateColor} onEndChange={updateColor} onChange={updateColor} />
                    <div style={{ "textAlign": "center", "top": "-110px", "position": "relative" }}><small>Opacity</small></div>
                    <div className="float-flex">
                        <div>&nbsp;</div>
                        <div><Button htmlType="submit" type="primary">Save</Button></div>
                    </div>
                </Form>
            </div>
        )
    }

    // Draw the row (Allow clicking on the color to edit)
    const drawRow = () => {
        return (
            <div>
                <div className="float-flex">
                    <Space>
                        <Overlay width="320px" component={<Gradient is_edit save={save} data={data} />}>
                            <Space>
                                {drawPreview()}
                                <wrap.tags><div style={{ "cursor": "pointer" }}>{name}</div></wrap.tags>
                            </Space>
                        </Overlay>
                    </Space>
                    <Space size={0}>
                        {(can_delete && <Tooltip placement="right" title={tt_gradient_delete}><Button onClick={() => remove(id, true)} type="link" icon={<TrashIcon />} size="small" /></Tooltip>)}
                        {(!can_delete && <Tooltip placement="right" title={tt_gradient_reset}><Button onClick={() => reset(id, true)} type="link" icon={<RedoOutlined />} size="small" /></Tooltip>)}
                        <Overlay width="320px" component={<Gradient is_edit save={save} data={data} />}>
                            <Button type="link" icon={<EditIcon />} size="small" />
                        </Overlay>
                    </Space>
                </div>
                <div className="shim" />
            </div>
        )
    }

    if (is_new || is_edit) {
        return drawEdit();
    } else {
        return drawRow();
    }

}